import React, { PropsWithChildren } from 'react';
import { BodyText, FlexDynamic, NamedButtonProps, PrimaryButton, FixedFooter } from '@minecraft.atoms';

type WizardFooterButtonProps = NamedButtonProps & { 'data-qa-id': string };
interface WizardFooterProps {
  label?: React.ReactNode;
  buttons?: WizardFooterButtonProps[];
}

export const WizardStepFooter = ({ buttons = [], label }: PropsWithChildren<WizardFooterProps>) => {
  return (
    <FixedFooter
      StartSlot={
        <FlexDynamic w="full">
          <BodyText>{label}</BodyText>
        </FlexDynamic>
      }
      EndSlot={
        <FlexDynamic
          direction="column"
          wrap="nowrap"
          gap="4"
          w="full"
          justifyContent="flex-end"
          mdProps={{ direction: 'row' }}
        >
          {buttons.map((buttonProps) => (
            <PrimaryButton key={buttonProps['data-qa-id']} type="button" {...buttonProps} />
          ))}
        </FlexDynamic>
      }
    />
  );
};
